// extracted by mini-css-extract-plugin
module.exports = {"sub-page":"MyCompanyTitle_sub-page__ArrLJ","active-cart-link":"MyCompanyTitle_active-cart-link__zuwJw"};